import styled from '@emotion/styled';
import { Button, ButtonProps, Icon, pxToRem } from '@lbcamden/lib-react';
import { Ref } from 'react';

const ButtonBase = ({ ref, ...props }: ButtonProps & { ref?: Ref<HTMLButtonElement> }) => (
  <Button ref={ref} $variant="tertiary" $color="primary" {...props}>
    <Icon icon="ui/edit" />
    Edit
  </Button>
);

export const EditButton = styled(ButtonBase)`
  position: relative;
  flex-shrink: 0;
  margin-left: auto;

  &:hover:not(:disabled) {
    color: ${({ theme }) => theme.colors.primaryHover};
  }

  svg {
    width: ${pxToRem(12)};
  }
`;
